module.exports = __webpack_public_path__ + "img/ic-paypal.4160a86d.svg";